import React, { Component } from "react";
import { applyDataTable } from '../../../custom/dataTable';
import Delete from '../../../../Assets/img/svg/delete.svg';
import del from "../../../../Assets/img/svg/Del.svg";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../Assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../../helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { CssTextField, CssTextFieldLast, CssTextFieldRow } from "../../../custom/textField"
import { inspectionSystem } from "../../../Constants";
import Save from "../../../../Assets/img/svg/save.svg";
import Cancel from "../../../../Assets/img/svg/cancel.svg";
import {warningAlert} from "../../../custom/alert"
import { errorToast } from "../../../../actions/CommonFunction";

class AddKNI extends Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.state = {
            isMobile: false,
            dataList: [],
            showrow: false,
            User: "",
            TypeId: 0,
            render: false,
            index: 0,
            name: "",
            nameError: false,
            section: "",
            cost: "",
            DeleteId: 0,
            autoFocus: false,
            autoFocus1: false,
            index: 0,
            HoverId: 0,
            Rows: 0,
            selectionStart: 0,
            update: "",
            Pagination: {
                "TotalPages": 0
            },
            response: 0,
            newpostdata: {
                "Id": 0,
                "ShipId": 0,
                "SectionId": 0,
                "InspectionId": 0,
                "Details": "",
                "Recommendation": "",
                "EstimatedCost": "",
                "IsDeleted": false,
                "CreatedBy": "",
                "ModifiedBy": "",
            },
            postdataname: {
                "Id": 0,
                "ShipId": 0,
                "Details": "",
                "Recommendation": "",
                "EstimatedCost": "",
                "IsDeleted": false,
                "CreatedBy": "",
                "ModifiedBy": "",
                "InspectionId": 0,
                "SectionId": 0
            }
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.newpostdata.ShipId = parseInt(localStorage.getItem("DashId"));
        this.state.newpostdata.InspectionId = parseInt(localStorage.getItem("InspectionId"));
        this.state.newpostdata.SectionId = inspectionSystem.keyNotableItems;
        this.state.newpostdata.CreatedBy = localStorage.getItem("UserRoles");
        this.state.newpostdata.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.User = localStorage.getItem("UserRoles");
        this.setState({})
        this.dataTable()
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.interval = setInterval(() => {
        this.resize1();
        }, 10);
    }

    dataTable = () => {
        let apiUrl = `${API.Get_Notable}?ShipId=${this.state.newpostdata.ShipId}&InspectionId=${this.state.newpostdata.InspectionId}&SectionId=${inspectionSystem.keyNotableItems}`;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.dataList = [];
                    this.setState({})
                    if (response?.data.length !== 0) {
                        this.state.dataList = response?.data;
                        response.data.sort((a, b) => {
                            return a.Id - b.Id;
                        });
                    }
                    this.state.dataList.push({
                        Id: 0,
                        ShipId: this.state.newpostdata.ShipId,
                        IsDeleted: false,
                        ModifiedBy: "",
                        CreatedBy: this.state.User,
                        InspectionId: this.state.newpostdata.InspectionId,
                        SectionId: inspectionSystem.keyNotableItems,
                        Details: "",
                        Recommendation: "",
                        EstimatedCost: "",
                    })
                    this.state.render = true;
                    this.setState({})
                    console.log(this.state.dataList)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                 // warningAlert("Something went wrong. Please try again.");
                errorToast();
                this.props.dispatch({ type: "CANCEL", data: true });
                if (error?.response?.status === 401) {

                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#KEY1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#KeyNotable1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#KeyNotable").addClass("d-none");
        $("#KeyNotable").removeClass("d-block");
        $("#KNIL").removeClass("active-color");
        $("#KNIT").removeClass("fw-bolder");
    }

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        } else {
            this.props.navigate("/sidebar");
        }
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    }
    resize1 = () => {
        $("#KEY1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#KeyNotable1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#KeyNotable").removeClass("d-none");
        $("#KeyNotable").addClass("d-block");
        $("#KNIL").addClass("active-color");
        $("#KNIT").addClass("fw-bolder");
    }

    deleterow = (data) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let apiUrl = API.Delete_Inspection + "?itemId=" + data;
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {

                if (response?.status === 200) {
                    this.dataTable()
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                // warningAlert("Something went wrong. Please try again.");
                errorToast();
                this.props.dispatch({ type: "CANCEL", data: true });
                if (error?.response?.status === 401) {

                }
            });
    };

    post_data = (data) => {
        let apiUrl = API.AddEdit_Notable;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.dataList.map((i) => (
                        i.Id == 0 ? i.Id = response.data : <></>
                    ))
                    this.setState({})
                    this.state.actNameFocus = false;
                    document.getElementById("actName" + response.data).focus()
                    this.state.nameError = false;
                    this.state.name = "";
                    this.state.section = "";
                    this.state.cost = "";
                    this.state.showrow = false;
                    let id = this.state.dataList.filter((i) => i.Id == 0)
                    if (id.length == 0) {
                        this.state.dataList.push({
                            Id: 0,
                            ShipId: this.state.newpostdata.ShipId,
                            IsDeleted: false,
                            ModifiedBy: "",
                            InspectionId: this.state.newpostdata.InspectionId,
                            SectionId: inspectionSystem.keyNotableItems,
                            Details: "",
                            Recommendation: " ",
                            EstimatedCost: "",
                        })
                    }
                    this.setState({})

                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                // warningAlert("Something went wrong. Please try again.");
                errorToast();
                this.props.dispatch({ type: "CANCEL", data: true });
                if (error?.response?.status === 401) {

                }
            });
    };

    put_data = (data, id) => {
        let apiUrl = `${API.AddEdit_Notable}?id=${id}`;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {

                if (response?.status === 200) {
                    // this.state.autoFocus = false;
                    // this.state.autoFocus1 = false;
                    // this.setState({})
                    // this.dataTable();
                } else {
                }
            })
            .catch((error) => {

                if (error?.response?.status === 401) {

                }
            });
    };

    deleteopalookdocs = (data) => {
        let apiUrl = API.AddEdit_Notable;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.index = 0;
                    this.setState({})
                    this.dataTable()
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                // warningAlert("Something went wrong. Please try again.");
                errorToast();
                this.props.dispatch({ type: "CANCEL", data: true });
                if (error?.response?.status === 401) {

                }
            });
    };

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.dataTable(this.state.searchData)
    }
    handleFocusDescription = (e, str, val) => {
        this.setState({ index: str.Id })
        if (str.Id == 0 && e.target.value.trim().length > 0) {
            document.getElementById('DescName').selectionStart = e.target.value.trim().length;
            document.getElementById('DescName').focus()
        }
    }
    handleFocusDescriptioncost = (e, str, val) => {
        this.setState({ index: str.Id })
        if (str.Id == 0 && e.target.value.trim().length > 0) {
            document.getElementById('Desccost').selectionStart = e.target.value.trim().length;
            document.getElementById('Desccost').focus()
        }
    }
    handleFocusDescriptioncost1 = (e, str, val) => {
        this.setState({ index: str.Id })
        if (e.target.value.trim().length > 0) {
            document.getElementById('Desccost' + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById('Desccost' + str.Id).focus()
        }
    }

    handleFocusDescription1 = (e, str, val) => {
        this.setState({ index: str.Id })
        if (e.target.value.trim().length > 0) {
            document.getElementById('DescName' + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById('DescName' + str.Id).focus()
        }
    }

    handleFocusNameChange = (e, str, val) => {
        this.setState({ index: str.Id })
        if (e.target.value.trim().length > 0) {
            document.getElementById("actName" + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById("actName" + str.Id).focus()
        }
    }

    handleFocusActChange = (e, str, val) => {
        this.setState({ actNameFocus: true, index: str.Id })
        if (str.Id == 0 && e.target.value.trim().length > 0) {
            document.getElementById('actName').selectionStart = e.target.value.trim().length;
            document.getElementById('actName').focus()
        }
    }
    
    handlePasteChange = (event, str, val, index) => {
        if (str.Id == 0 && event.target.value.trim() != "") {
            this.state.newpostdata.Details = event.clipboardData.getData("text").trim();
            this.state.newpostdata.Recommendation = str.Recommendation.trim();
            this.state.newpostdata.EstimatedCost = str.EstimatedCost.trim();
            this.setState({})

        }
        this.state?.dataList?.map((i) => (
            i.Id == 0 ? i.Details.trim() == "" ? (
                this.post_data(this.state.newpostdata),
                this.state.actNameFocus = true
            )
                : "" : ""
        ))
        this.setState({})
    }

    hoverHeight = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data2 = $("#actCost" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actCost" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.HoverId = i.Id;
        if (data > data1) {
            this.state.Rows = data + 1;
        }

        else {
            this.state.Rows = data1 + 1;
        }
        this.setState({})
    }

    HoverHeight = (e, i) => {
        this.state.HoverId = i;
        this.setState({})
    }

    HoverHeight1 = (e, i) => {
        this.state.HoverId1 = i;
        this.setState({})
    }
    HoverHeight2 = (e, i) => {
        this.state.HoverId2 = i;
        this.setState({})
    }

    hoverHeight1 = (e, i) => {
        this.setState({ FocusRowId: i.Id })
    }

    handleInputChange = (e, str, val, index) => {
        console.log(e.target.value, str, val)
        if (val == "Details") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Details = e.target.value : ""
            ))
            if (str.Id == 0 && e.target.value.length == 1 && e.target.value.trim() != "") {
                console.log(e.target.value, str, val)
                this.state.newpostdata.Details = e.target.value;
                this.state.newpostdata.Recommendation = str.Recommendation != "" ? str.Recommendation.trim() : "";
                this.state.newpostdata.EstimatedCost = str.EstimatedCost != "" ? str.EstimatedCost.trim() : "";
                this.state.newpostdata.ShipId = str.ShipId;
                this.state.newpostdata.IsDeleted = false;
                this.state.newpostdata.CreatedBy = this.state.User;
                this.state.newpostdata.InspectionId = str.InspectionId;
                this.state.newpostdata.SectionId = str.SectionId;
                this.setState({});
                this.post_data(this.state.newpostdata)
                // this.state.actNameFocus = true
            }
        }
        if (val == "Recommendation") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Recommendation = e.target.value : ""
            ))
        }
        if (val == "EstimatedCost") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.EstimatedCost = e.target.value : ""
            ))
        }
        this.setState({})
    }

    postDataBlur = (e, str, val) => {
        if (val == "Details") {
            if (str.Id != 0 && e.target.value.trim() != "") {
                let data = {
                    Id: str.Id,
                    ShipId: this.state.newpostdata.ShipId,
                    IsDeleted: false,
                    ModifiedBy: localStorage.getItem("UserRoles"),
                    InspectionId: this.state.newpostdata.InspectionId,
                    SectionId: inspectionSystem.keyNotableItems,
                    Details: str.Details.trim(),
                    Recommendation: str.Recommendation.trim(),
                    EstimatedCost: str.EstimatedCost.trim(),
                }
                this.put_data(data, data.Id)
                this.setState({})
            }
            if (str.Id != 0 && e.target.value.trim() == "") {
                this.deleterow(str.Id);
            }
        }
        if (val == "Recommendation") {
            let data = {
                Id: str.Id,
                ShipId: this.state.newpostdata.ShipId,
                IsDeleted: false,
                ModifiedBy: localStorage.getItem("UserRoles"),
                InspectionId: this.state.newpostdata.InspectionId,
                SectionId: inspectionSystem.keyNotableItems,
                Details: str.Details.trim(),
                Recommendation: e.target.value.trim(),
                EstimatedCost: str.EstimatedCost.trim()
            }
            if (data.Id != 0) {
                this.put_data(data, data.Id)
            }
        }
        if (val == "EstimatedCost") {
            let data = {
                Id: str.Id,
                ShipId: this.state.newpostdata.ShipId,
                IsDeleted: false,
                ModifiedBy: localStorage.getItem("UserRoles"),
                InspectionId: this.state.newpostdata.InspectionId,
                SectionId: inspectionSystem.keyNotableItems,
                Details: str.Details.trim(),
                Recommendation: str.Recommendation.trim(),
                EstimatedCost: e.target.value.trim()
            }
            if (data.Id != 0) {
                this.put_data(data, data.Id)
            }
        }
        this.state.index = 0;
        this.state.FocusId1 = 0;
        this.state.FocusId2 = 0;
        this.setState({})
    }

    OpenPopup = (data) => {
        this.state.DeleteId = data;
        this.setState({})
        window.$("#deletepopup").modal("show");
    };

    DeleteItem = () => {
        this.deleterow(this.state.DeleteId)
        window.$("#deletepopup").modal("hide");
    };

    AddCancel1 = () => {
        this.props.navigate(`/shiplist`)
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id={"KEY" + "1"} className='textNaviIcon' primary="Inspection Tasks" />
                                            <NavigateNextIcon id="KEY" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Key Notable Items</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto mt-138" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75 }}>

                    {this.state.isMobile ? (
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr>
                                    <td className="border-right text-center">
                                        <i
                                            class="fa fa-arrow-left cursorPointer"
                                            onClick={this.AddCancel1}
                                        ></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    ) : (
                        <>
                            <table className="dataTable" width="100%">
                                <tbody>
                                    <tr>
                                        <td width="5%" className="border-right text-center">
                                            <i
                                                class="fa fa-arrow-left cursorPointer"
                                                onClick={this.AddCancel1}
                                            ></i>
                                        </td>
                                        <td className="" width="95%">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    )}
                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-12 pt-2">
                                {this.state.isMobile ? <></> : <h6>Key Notable Items</h6>}
                            </div>
                        </div>
                        <div className={
                            this.state.isMobile
                                ? "col-12 px-4 pt-2 mt-1 mx-1"
                                : "col-12 px-3 pt-2 mt-1 mx-1"
                        }>
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right" width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Items</span></th>
                                            <th className="border-top border-right border-left" width="35%" style={{ minWidth: '35%', maxWidth: '35%' }}><span className="spandoc-thead">Details</span></th>
                                            <th className="border-top border-right" width="34%" style={{ minWidth: '34%', maxWidth: '34%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Due Date / Recommendation</span></th>
                                            <th className="border-top border-right" width="28%" style={{ minWidth: '28%', maxWidth: '28%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Estimated Cost (USD)</span></th>
                                            <th className="border-top border-right" width="10%" style={{ minWidth: '10%', maxWidth: '10%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataList && this.state?.dataList.map((i, index) => (
                                            i.Id != 0 ?
                                                <tr className="border-top">
                                                    <td className="border-right text-center align-middle"><span className="spandoc-td">{index + 1}</span></td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '35%', maxWidth: '35%' }}>
                                                        <div className={(this.state.HoverId == i.Id || this.state.index == i.Id) ? "border-bg" : "border-bg-none"}>
                                                            <CssTextFieldRow
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                // autoFocus={this.state.index == i.Id ? true : false}
                                                                id={"actName" + i.Id}
                                                                onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                style={{ height: ($("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight()) ? ($("#actName" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actName" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13 : ($("#actDesc" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actDesc" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13, marginTop: "-2px" }}
                                                                onFocus={(e) => this.handleFocusNameChange(e, i, 'Details')}
                                                                // onFocusOut={(e) => this.setState({ index: 0 })}
                                                                onChange={(e) => this.handleInputChange(e, i, 'Details', index)}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Details')}
                                                                value={i?.Details}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                        </div>
                                                        {(i.Details == "") ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Details is required</span> : <></>}
                                                    </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right`} >

                                                        <div className={(this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) ? "border-bg" : "border-bg-none"}>
                                                            <CssTextFieldRow
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id={"actDesc" + i.Id}
                                                                onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                                onMouseLeave={(e) => this.setState({ HoverId1: 0 })}
                                                                onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                onFocusOut={(e) => this.setState({ FocusId1: 0, index: 0 })}
                                                                onChange={(e) => this.handleInputChange(e, i, 'Recommendation')}
                                                                style={{ height: ($("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight()) ? ($("#actName" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actName" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13 : ($("#actDesc" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actDesc" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13, marginTop: "-2px" }}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Recommendation')}
                                                                value={i?.Recommendation}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                        </div>
                                                    </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right`} >

                                                        <div className={(this.state.HoverId2 == i.Id || this.state.FocusId2 == i.Id) ? "border-bg" : "border-bg-none"}>
                                                            <CssTextFieldRow
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id={"actcost" + i.Id}
                                                                onMouseEnter={(e) => this.setState({ HoverId2: i.Id })}
                                                                onMouseLeave={(e) => this.setState({ HoverId2: 0 })}
                                                                onFocus={(e) => this.setState({ FocusId2: i.Id })}
                                                                onFocusOut={(e) => this.setState({ FocusId2: 0, index: 0 })}
                                                                onChange={(e) => this.handleInputChange(e, i, 'EstimatedCost')}
                                                                style={{ height: ($("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight()) ? ($("#actName" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actName" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13 : ($("#actDesc" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actDesc" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13, marginTop: "-2px" }}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'EstimatedCost')}
                                                                value={i?.EstimatedCost}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                        </div>
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        <img src={Delete} className="cursorPointer" onClick={() => this.OpenPopup(i.Id)} />
                                                    </td>
                                                </tr> : <></>
                                        ))}
                                        {this.state?.dataList && this.state?.dataList.map((i, index) => (
                                            i.Id == 0 ?
                                                <tr className="border-top">
                                                    <td className="border-right text-center align-middle"><span className="spandoc-td"></span></td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '35%', maxWidth: '35%' }}>
                                                        {/* {(i.Details == "") ? */}
                                                        <CssTextFieldLast
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            id="actName"
                                                            autoFocus={this.state.actNameFocus}
                                                            onFocus={(e) => this.handleFocusActChange(e, i, 'Details')}
                                                            onChange={(e) => this.handleInputChange(e, i, 'Details')}
                                                            onBlur={(e) => this.postDataBlur(e, i, 'Details')}
                                                            onPaste={(e) => this.handlePasteChange(e, i, 'Details')}
                                                            value={i?.Details}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} />
                                                        {/* //      :
                                                            // <CssTextField 
                                                            //     multiline
                                                            //     fullWidth
                                                            //     variant="outlined"
                                                            //     type="text"
                                                            //     id="actName"
                                                            //     autoFocus={this.state.actNameFocus}
                                                            //     onFocus={(e) => this.handleFocusActChange(e, i, 'Details')}
                                                            //     onChange={(e) => this.handleInputChange(e, i, 'Details')}
                                                            //     onPaste={(e) => this.handlePasteChange(e, i, 'Details')}
                                                            //     onBlur={(e) => this.postDataBlur(e, i, 'Details')}
                                                            //     value={i.Details}
                                                            //     InputProps={{
                                                            //         className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            //     }} />}*/}
                                                        {(i.Details.trim() == "" && (i.Recommendation.trim() != "" || i.EstimatedCost.trim() != "")) ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Deatils is required</span> : <></>}
                                                    </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right`} style={{ minWidth: '34%', maxWidth: '34%' }}>
                                                        {(i.Recommendation == "") ?
                                                            <CssTextFieldLast
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id="DescName"
                                                                onFocus={(e) => this.handleFocusDescription(e, i, 'Recommendation')}
                                                                onChange={(e) => this.handleInputChange(e, i, 'Recommendation')}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Recommendation')}
                                                                value={i.Recommendation}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                            :
                                                            <CssTextFieldLast
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id="DescName"
                                                                onFocus={(e) => this.handleFocusDescription(e, i, 'Recommendation')}
                                                                onChange={(e) => this.handleInputChange(e, i, 'Recommendation')}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Recommendation')}
                                                                value={i.Recommendation}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                        }
                                                    </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right`} style={{ minWidth: '28%', maxWidth: '28%' }}>
                                                        {i.EstimatedCost == "" ?
                                                            <CssTextFieldLast
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id="Desccost"
                                                                onFocus={(e) => this.handleFocusDescriptioncost(e, i, 'EstimatedCost')}
                                                                onChange={(e) => this.handleInputChange(e, i, 'EstimatedCost')}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'EstimatedCost')}
                                                                value={i.EstimatedCost}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                            : <CssTextFieldLast
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id="Desccost"
                                                                onFocus={(e) => this.handleFocusDescriptioncost(e, i, 'EstimatedCost')}
                                                                onChange={(e) => this.handleInputChange(e, i, 'EstimatedCost')}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'EstimatedCost')}
                                                                value={i.EstimatedCost}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                        }
                                                    </td>

                                                </tr> : <></>
                                        ))}
                                        {this.state.showrow ?
                                            <tr className="border-top">
                                                <td></td>
                                                <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '35%', maxWidth: '35%' }}>
                                                    <CssTextFieldLast
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        size="small"
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </td>
                                                <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-left`} style={{ minWidth: '34%', maxWidth: '34%' }}>
                                                    <CssTextFieldLast
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        size="small"
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </td>
                                                <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-left`} style={{ minWidth: '28%', maxWidth: '28%' }}>
                                                    <CssTextFieldLast
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        size="small"
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </td>

                                            </tr> : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade p-5 mt-5"
                    id="deletepopup"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="deletepopupLabel"
                    aria-hidden="true"
                    style={{
                        top: "13%",
                        left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
                    }}
                >
                    <div className="modal-dialog" role="document">
                        <div
                            className={
                                this.state.isMobile ? "modal-content" : "modal-content p-3"
                            }
                        >
                            <div className="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 className="fw-bold">
                                        Are you sure you want to delete?
                                    </h5>{" "}
                                </div>
                            </div>
                            <div className="modal-footer border-top-0 m-auto">
                                <button
                                    type="button"
                                    data-dismiss="modal"
                                    className={
                                        this.state.isMobile
                                            ? "btn btn-secondary"
                                            : " btn btn-secondary py-2 px-4"
                                    }
                                    style={{ backgroundColor: "#499AC8", border: "none" }}
                                    onClick={() => this.DeleteItem()}
                                >
                                    <span className="">Delete</span>
                                </button>
                                <button
                                    type="button"
                                    id="closemodal"
                                    className={
                                        this.state.isMobile
                                            ? "btn btn-secondary"
                                            : " btn btn-secondary py-2 px-4"
                                    }
                                    onClick={() => window.$("#deletepopup").modal("hide")}
                                    style={{
                                        backgroundColor: "#EBEBEB",
                                        border: "none",
                                        color: "#111010",
                                    }}
                                >
                                    <span className="">Cancel</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddKNI))
);
